<template>
  <div>
    <imageUploaderModal
      v-if="cropper === true && type === 'image'"
      :height="height"
      :width="width"
      :resize="resize"
      :path="path"
    />
    <imageUploaderInline v-else-if="cropper === false && type === 'image'" :height="height" :width="width" :path="path"/>

    <fileUploaderInline v-else-if="type === 'file'" :height="height" :width="width" :path="path"/>
  </div>
</template>1

<script>
export default {
  components: {
    imageUploaderModal: () => import("./components/imageUploaderModal"),
    imageUploaderInline: () => import("./components/imageUploaderInline"),
    fileUploaderInline: () => import("./components/fileUploaderInline"),
  },
  props: {
    type: {
      type: String,
      default: "image",
    },
    cropper: {
      type: Boolean,
      default: false,
    },
    resize: {
      type: Boolean,
      default: false,
    },
    path: {
      type: String,
      default: "medias",
    },
    width: {
      type: Number,
      default: 600,
    },
    height: {
      type: Number,
      default: 600,
    },
  },
  data: () => ({}),
  watch: {},
  methods: {},
};
</script>

<style lang="scss">
</style>
